import { useEffect } from 'react'
import { ChatPanel } from '@diwata/hearth'
import { useUI } from '@/store/ui'

/**
 * The persistent DAEMON chat rail. The collapsible shell + ⌘. toggle stay local; the
 * conversation itself is the shared `<ChatPanel>` (via the FamiliarProvider mounted in
 * main.tsx), so apex now gets tool cards, the confirm gate, and voice — the things the old
 * hand-rolled sidebar lacked.
 */
export function DaemonSidebar() {
  const { sidebarOpen, toggleSidebar } = useUI()

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === '.') {
        e.preventDefault()
        toggleSidebar()
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [toggleSidebar])

  if (!sidebarOpen) {
    return (
      <div className="ap-sidebar ap-sidebar--collapsed">
        <button
          className="ap-sidebar-toggle"
          style={{ margin: '12px auto', display: 'block' }}
          onClick={toggleSidebar}
          title="Open DAEMON (⌘.)"
        >
          ⊙
        </button>
      </div>
    )
  }

  return (
    <div className="ap-sidebar">
      <div className="ap-sidebar-header">
        <span>DAEMON</span>
        <button className="ap-sidebar-toggle" onClick={toggleSidebar} title="Collapse (⌘.)">
          ⟩
        </button>
      </div>
      <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <ChatPanel sessionId="apex" familiarName="DAEMON" />
      </div>
    </div>
  )
}
